<div>
  <ng-content> </ng-content>

  <div style="color: red" *ngIf="control && (!!control.dirty || !!control.touched) && control.hasError('required')">必填校验.</div>
</div>
